import React, {useContext, useState, useEffect} from "react";
import {Input} from "../../../styles/Forms";
import {Grid, Col} from "../../../styles/Grid";
import {Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";
import {AppButton} from "../../../styles/Butttons";
import styled from "styled-components";
import {FacilitatorsContext} from "../../../context/FacilitatorsProvider";
import AppLoader, {LoadComponet} from "../../../components/loaders/Loader";
import {useParams, useHistory} from "react-router-dom";
import {ReactComponent as PlusIcon} from "../../../assets/icons/plus.svg";
import {ReactComponent as RemoveIcon} from "../../../assets/icons/cancel.svg";
import {AddFacilitatorCourse} from "../../../services/FacilitatorsService";

const selectBackColor = (type) => {
   type = Number(type);
   switch (type) {
      case 1:
         return "#af0069";
      case 2:
         return "#8e44ad";
      case 3:
         return "#2980b9";
      case 5:
         return "#8e44ad";
      default:
         return "#32529d";
   }
};

export default function FormPartFour({save, sections, theme, idCourse}) {
   const [currentTheme, setTheme] = useState({});
   const [isSaving, setSaving] = useState(false);
   const {visibleList, isLoading} = useContext(FacilitatorsContext);
   const [selectedId, setSelectedId] = useState([]);
   const [currentSearch, setSearch] = useState(""); // lista completa
   const [filtered, setFiltered] = useState([]); // lista filtrara
   let {type} = useParams();
   let history = useHistory();

   useEffect(() => {
      setTheme({...theme, back: selectBackColor(type)});
   }, [type]);

   useEffect(() => {
      setFiltered(visibleList);
   }, [visibleList]);

   useEffect(() => {
      applySearch();
   }, [currentSearch]);

   const toggleId = (id) => {
      let exist = selectedId.find((num) => num === id);
      if (exist) {
         /// QUITAR
         let newIds = selectedId.filter((num) => num !== id);
         setSelectedId(newIds);
      } else {
         let newIds = [...selectedId, id];
         // console.log(newIds);
         setSelectedId(newIds);
      }
   };

   const applySearch = () => {
      let tosearch = currentSearch.toLowerCase();

      if (currentSearch.length > 2) {
         let newList = visibleList.filter((facilitator) => {
            let name = facilitator.facilitatorName.toLowerCase();
            let lastN = facilitator.facilitatorLastName.toLowerCase();

            return name.indexOf(currentSearch.toLowerCase()) > -1 || lastN.indexOf(tosearch) > -1;
         });
         setFiltered(newList);
      } else {
         setFiltered(visibleList);
      }
   };

   const AddAllIds = (ind = 0) => {
      setSaving(true);
      if (ind < selectedId.length) {
         console.log("Guardar", selectedId[ind]);
         registerFacilitator(selectedId[ind], ind);
      } else {
         setSaving(false);
         history.goBack();
      }
   };

   const registerFacilitator = (idFacilitator, ind) => {
      let toSave = {
         idCourse,
         idFacilitator,
      };
      AddFacilitatorCourse(toSave)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            console.log(resp);
            AddAllIds(ind + 1);
         })
         .catch((e) => {
            AddAllIds(ind + 1);
            console.log(e);
         });
   };

   let isSelected = (id) => selectedId.find((num) => num === id);

   return (
      <>
         <FormStyled as="div">
            <Grid>
               <Col large={6}>
                  <TitleSecion>Facilitadores:</TitleSecion>
               </Col>
               <Col large={3} offsetL={3}>
                  <Input
                     type="search"
                     placeholder="Buscar facilitadores"
                     onChange={(e) => {
                        setSearch(e.target.value);
                     }}
                     value={currentSearch}
                  />
               </Col>
            </Grid>
            <Grid>
               {isLoading.visibles ? (
                  <LoadComponet isVisible={true} />
               ) : (
                  React.Children.toArray(
                     filtered.map((facil) => {
                        return (
                           <DotFacilitator
                              className={isSelected(facil.idFacilitator) ? "selected" : ""}
                              back={currentTheme.back}
                              onClick={() => toggleId(facil.idFacilitator)}
                           >
                              <p>{`${facil.facilitatorName} ${facil.facilitatorLastName}`}</p>
                              <span>
                                 <PlusIcon width="1em" height="1em" fill={currentTheme.back} className="add" />
                                 <RemoveIcon width="1em" height="1em" fill="white" className="remove" />
                              </span>
                           </DotFacilitator>
                        );
                     }),
                  )
               )}
               <Col large={2} offsetL={10}>
                  <AppButton onClick={() => AddAllIds()}>GUARDAR</AppButton>
               </Col>
            </Grid>
         </FormStyled>
         <AppLoader isVisible={isSaving} />
      </>
   );
}

const TitleSecion = styled.p`
   font-size: 1.5em;
   font-weight: 400;
   color: #1c355e;
   margin: 1em 0 1.5em 0;
`;

const DotFacilitator = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-right: 0.5em;
   margin-bottom: 0.3em;
   padding: 0.3em 0.5em;
   // border-radius: 1em;
   // border-top-right-radius: 1em;
   // border-bottom-right-radius: 1em;
   user-select: none;
   transition: color 420ms linear, background 600ms ease-out;
   border: 1px solid ${(props) => props.back || "#32529d"};
   color: rgba(150, 150, 150, 0.9);

   & p {
      font-size: 0.9em;
      line-height: 1em;
      margin: 0;
   }

   & span {
      margin-left: 0.5em;
      cursor: pointer;

      & .remove {
         display: none;
      }
   }

   &.selected,
   &:hover {
      background: ${(props) => props.back || "#32529d"};
      color: white;
      transition: color 420ms linear, background 600ms ease-out;
      & span {
         & .add {
            fill: white;
         }
      }
   }

   &.selected {
      &:hover {
         background: white;
         color: rgba(150, 150, 150, 0.9);
         transition: color 420ms linear, background 600ms ease-out;
         & span {
            & .remove {
               fill: ${(props) => props.back || "#32529d"};
            }
         }
      }

      & span {
         & .remove {
            display: block;
         }
         & .add {
            display: none;
         }
      }
   }
`;

const FormStyled = styled.form`
   padding: 2em 0;
   .buttonModal {
      margin-top: 2em;
   }
   textarea {
      font-family: Montserrat;
      resize: none;
      height: 160px;
   }
   & .maxMargin {
      margin-top: 1em;
   }
   & .imgs {
      & .row {
         width: 100%;
      }
   }

   & .buttonAction {
      text-align: center;
      height: 43px;
      box-sizing: border-box;
      user-select: none;

      &.disabled {
         pointer-events: none;
         color: grey;
         opacity: 0.5;
      }

      & span {
         font-size: 1.1em;
      }
   }
`;
